module.exports = __webpack_public_path__ + "img/file-upload.1b224aa3.svg";